export default __webpack_public_path__ + "static/media/sweet_text.2e73963e.mp3";